import { Progress } from 'src/app/components/Elements/Progress';
import { LEGACY_SKELETON_LOADER } from 'src/consts/testIDs';

import { SkeletonContainer } from './styles';

export interface SkeletonProps {
  backgroundColor?: string;
  spinnerColor?: string;
  spinnerSize?: number;
  spinnerThickness?: number;
}

export const Skeleton = ({
  backgroundColor = '#fff',
  spinnerColor = '#0f3c6c',
  spinnerSize = 20,
  spinnerThickness = 2,
}: SkeletonProps) => {
  return (
    <SkeletonContainer backgroundColor={backgroundColor} data-testid={LEGACY_SKELETON_LOADER}>
      <Progress size={spinnerSize} color={spinnerColor} thickness={spinnerThickness} />
    </SkeletonContainer>
  );
};
